<div class="tw-flex tw-flex-col tw-w-full tw-box-border tw-h-full tw-min-h-0 tw-py-4 tw-px-4 lg:tw-px-10 lg:tw-py-6 xl:tw-px-[72px]">
  <div class="tw-flex tw-flex-col tw-gap-4">
    <div class="tw-flex tw-flex-col tw-gap-0.5 lg:tw-gap-1 tw-font-inter">
        <h1 class="tw-font-bold tw-text-lg lg:tw-text-[28px]">Archive</h1>
        <p class="tw-font-normal tw-text-sm lg:tw-text-base tw-text-gray-500">View and manage archived items</p>
    </div>
    @if (selectedItems().length) {
      <div class="tw-flex lg:tw-hidden tw-items-center tw-justify-between tw-w-full tw-mb-4 tw-h-[42px]">
        <p class="tw-text-gray-700 tw-font-inter tw-font-medium tw-text-sm">{{ selectedItemsSummary() }}</p>
        <div class="tw-flex tw-items-center tw-gap-2">
          <button
            type="button"
            class="tw-flex tw-items-center tw-gap-2 tw-text-blue-600 tw-font-inter tw-font-medium tw-text-sm"
            (click)="openRestoreModal()"
          >
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_47342_1387)">
                <path d="M1.75736 1.75736C0.918246 2.59648 0.346802 3.66557 0.115291 4.82946C-0.11622 5.99335 0.0026002 7.19975 0.456726 8.2961C0.910853 9.39246 1.67989 10.3295 2.66658 10.9888C3.65328 11.6481 4.81332 12 6.00001 12C7.18669 12 8.34673 11.6481 9.33342 10.9888C10.3201 10.3295 11.0892 9.39245 11.5433 8.29609C11.9974 7.19974 12.1162 5.99334 11.8847 4.82945C11.6532 3.66556 11.0817 2.59647 10.2426 1.75735C9.11741 0.632137 7.59129 -1.50029e-06 5.99999 0C4.4087 1.5003e-06 2.88258 0.632143 1.75736 1.75736ZM9.42557 5.77157C8.84357 5.18958 8.05422 4.86262 7.23115 4.86262C6.40808 4.86262 5.61873 5.18958 5.03673 5.77158L6.35717 7.09202L2.51475 7.09202V3.24958L3.83516 4.57002C4.36094 4.04418 5.03097 3.68624 5.76037 3.54155C6.48976 3.39685 7.24569 3.47192 7.93238 3.75723C8.61908 4.04254 9.20563 4.52526 9.61773 5.14423C10.0298 5.76319 10.2489 6.49056 10.2473 7.23416C10.1136 6.68016 9.82916 6.17396 9.42557 5.77157Z" fill="#1C64F2"/>
              </g>
              <defs>
                <clipPath id="clip0_47342_1387">
                  <rect width="12" height="12" fill="white"/>
                </clipPath>
              </defs>
            </svg>
            Restore
          </button>
          <div class="tw-w-px tw-h-4 tw-bg-gray-200"></div>
          <button
            type="button"
            class="tw-flex tw-items-center tw-gap-2 tw-text-red-700 tw-font-inter tw-font-medium tw-text-sm"
            (click)="openDeleteModal()"
          >
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_47342_11639)">
                <path d="M10.8908 2.52632H8.4464V1.26316C8.4464 0.928148 8.31763 0.606858 8.08842 0.36997C7.85921 0.133082 7.54833 0 7.22418 0H4.77973C4.45558 0 4.1447 0.133082 3.91549 0.36997C3.68628 0.606858 3.55751 0.928148 3.55751 1.26316V2.52632H1.11306C0.950987 2.52632 0.795549 2.59286 0.680943 2.7113C0.566338 2.82975 0.501953 2.99039 0.501953 3.15789C0.501953 3.3254 0.566338 3.48604 0.680943 3.60449C0.795549 3.72293 0.950987 3.78947 1.11306 3.78947H1.72418V10.7368C1.72418 11.0719 1.85294 11.3931 2.08216 11.63C2.31137 11.8669 2.62224 12 2.9464 12H9.05751C9.38166 12 9.69254 11.8669 9.92175 11.63C10.151 11.3931 10.2797 11.0719 10.2797 10.7368V3.78947H10.8908C11.0529 3.78947 11.2084 3.72293 11.323 3.60449C11.4376 3.48604 11.502 3.3254 11.502 3.15789C11.502 2.99039 11.4376 2.82975 11.323 2.7113C11.2084 2.59286 11.0529 2.52632 10.8908 2.52632ZM4.77973 1.26316H7.22418V2.52632H4.77973V1.26316ZM5.39084 9.47368C5.39084 9.64119 5.32646 9.80183 5.21185 9.92028C5.09725 10.0387 4.94181 10.1053 4.77973 10.1053C4.61765 10.1053 4.46222 10.0387 4.34761 9.92028C4.233 9.80183 4.16862 9.64119 4.16862 9.47368V5.05263C4.16862 4.88513 4.233 4.72448 4.34761 4.60604C4.46222 4.48759 4.61765 4.42105 4.77973 4.42105C4.94181 4.42105 5.09725 4.48759 5.21185 4.60604C5.32646 4.72448 5.39084 4.88513 5.39084 5.05263V9.47368ZM7.83529 9.47368C7.83529 9.64119 7.7709 9.80183 7.6563 9.92028C7.54169 10.0387 7.38625 10.1053 7.22418 10.1053C7.0621 10.1053 6.90666 10.0387 6.79205 9.92028C6.67745 9.80183 6.61306 9.64119 6.61306 9.47368V5.05263C6.61306 4.88513 6.67745 4.72448 6.79205 4.60604C6.90666 4.48759 7.0621 4.42105 7.22418 4.42105C7.38625 4.42105 7.54169 4.48759 7.6563 4.60604C7.7709 4.72448 7.83529 4.88513 7.83529 5.05263V9.47368Z" fill="#C81E1E"/>
              </g>
              <defs>
                <clipPath id="clip0_47342_11639">
                  <rect width="12" height="12" fill="white"/>
                </clipPath>
              </defs>
            </svg>
            Delete
          </button>
        </div>
      </div>
    }

    <div class="tw-flex tw-items-center tw-gap-2 tw-w-full tw-mb-4 tw-h-[42px]"
         [ngClass]="selectedItems().length ? 'tw-hidden lg:tw-flex' : 'tw-flex'">
      <div class="tw-flex tw-items-center tw-gap-2 tw-min-w-0 tw-shrink tw-w-full lg:tw-w-auto">
        <app-search-field
          class="tw-flex-1 lg:tw-flex-none"
          [placeholder]="'Search by item name'"
          [widthClass]="'lg:tw-w-[276px] xl:tw-w-80'"
          (searchChange)="onSearchChange($event)"
          [initialValue]="searchTerm()"
        />

        <app-filter-button
          [activeCount]="activeFilterCount()"
        />
      </div>

      <div class="tw-hidden lg:tw-flex tw-items-center tw-gap-3 tw-shrink-0">
        <app-dropdown
          class="archived-filter-dropdown"
          [dropdownOptions]="typeFilterDropdownOptions()"
          [widthInPX]="'115px'"
          [heightInPX]="97"
          (optionClicked)="onTypeFilterDropdownSelect($event)"
          (dropdownOpened)="isTypeFilterDropdownOpen.set(true)"
          (dropdownClosed)="isTypeFilterDropdownOpen.set(false)"
        >
          <app-filter-dropdown-trigger
            [label]="selectedTypeLabel()"
            [ariaLabel]="'Filter by type'"
            [isActive]="appliedFilters().type !== 'all'"
            [isOpen]="isTypeFilterDropdownOpen()"
          />
        </app-dropdown>

        <div class="tw-relative tw-shrink-0 archived-date-filter-host">
          <app-dropdown
            class="archived-filter-dropdown"
            [dropdownOptions]="dateRangeFilterDropdownOptions()"
            [widthInPX]="'154px'"
            [heightInPX]="242"
            (optionClicked)="onDateRangeFilterDropdownSelect($event)"
            (dropdownOpened)="isDateRangeFilterDropdownOpen.set(true)"
            (dropdownClosed)="isDateRangeFilterDropdownOpen.set(false)"
          >
            <app-filter-dropdown-trigger
              [label]="selectedDateRangeLabel()"
              [ariaLabel]="'Filter by date range'"
              [isActive]="appliedFilters().dateRange !== 'any'"
              [isOpen]="isDateRangeFilterDropdownOpen()"
            />
          </app-dropdown>

          <app-date-range-picker
            #desktopCustomDateRangePicker
            class="archived-custom-date-range-picker"
            [startDate]="appliedFilters().customArchivedFrom"
            [endDate]="appliedFilters().customArchivedTo"
            [showIndefiniteOption]="false"
            [isIndefinitely]="false"
            [maxSelectableDate]="archivedDatePickerMaxDate"
            [initialVisibleMonthDate]="archivedDatePickerMaxDate"
            (rangeSelected)="onCustomDateRangeSelected($event)"
          />
        </div>

        @if (activeFilterCount() > 0) {
          <button
            type="button"
            class="tw-flex tw-shrink-0 tw-items-center tw-justify-center tw-gap-1 tw-p-1 tw-rounded-lg tw-bg-transparent tw-border-0 tw-cursor-pointer tw-font-inter tw-text-sm tw-font-medium tw-text-blue-600 tw-whitespace-nowrap"
            (click)="onClearAllFilters()"
          >
            <span class="tw-flex tw-items-center tw-justify-center tw-w-3.5 tw-h-3.5 tw-shrink-0">
              <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <path d="M6.00823 5L9.78232 1.22591C9.85042 1.16014 9.90474 1.08146 9.94211 0.994463C9.97948 0.90747 9.99915 0.813906 9.99997 0.71923C10.0008 0.624554 9.98275 0.530662 9.9469 0.443032C9.91105 0.355403 9.85811 0.275791 9.79116 0.208843C9.72421 0.141894 9.6446 0.088949 9.55697 0.053097C9.46934 0.017245 9.37545 -0.000795788 9.28077 2.69221e-05C9.18609 0.000849632 9.09253 0.0205196 9.00554 0.057889C8.91854 0.0952584 8.83986 0.149579 8.77409 0.217681L5 3.99177L1.22591 0.217681C1.09143 0.0877961 0.911317 0.015926 0.724362 0.0175506C0.537407 0.0191752 0.358569 0.0941644 0.226367 0.226367C0.0941644 0.358569 0.0191752 0.537407 0.0175506 0.724362C0.015926 0.911317 0.0877961 1.09143 0.217681 1.22591L3.99177 5L0.217681 8.77409C0.149579 8.83986 0.0952584 8.91854 0.057889 9.00554C0.0205196 9.09253 0.000849632 9.18609 2.69221e-05 9.28077C-0.000795788 9.37545 0.017245 9.46934 0.053097 9.55697C0.088949 9.6446 0.141894 9.72421 0.208843 9.79116C0.275791 9.85811 0.355403 9.91105 0.443032 9.9469C0.530662 9.98275 0.624554 10.0008 0.71923 9.99997C0.813906 9.99915 0.90747 9.97948 0.994463 9.94211C1.08146 9.90474 1.16014 9.85042 1.22591 9.78232L5 6.00823L8.77409 9.78232C8.90857 9.9122 9.08868 9.98407 9.27564 9.98245C9.46259 9.98082 9.64143 9.90583 9.77363 9.77363C9.90583 9.64143 9.98082 9.46259 9.98245 9.27564C9.98407 9.08868 9.9122 8.90857 9.78232 8.77409L6.00823 5Z" fill="#1C64F2"/>
              </svg>
            </span>
            Clear all
          </button>
        }
      </div>

      @if (selectedItems().length) {
        <div class="tw-hidden lg:tw-flex tw-items-center tw-gap-3 tw-ml-auto tw-shrink-0">
          <p class="tw-whitespace-nowrap tw-text-gray-700 tw-font-inter tw-font-medium tw-text-sm">{{ selectedItemsSummary() }}</p>
          <div class="tw-flex tw-items-center tw-gap-2">
            <button
              type="button"
              class="tw-flex tw-items-center tw-gap-2 tw-text-blue-600 tw-font-inter tw-font-medium tw-text-sm tw-border tw-border-blue-600 tw-px-5 tw-rounded-lg tw-bg-white tw-h-[42px] tw-whitespace-nowrap"
              (click)="openRestoreModal()"
            >
              <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_47342_1387)">
                  <path d="M1.75736 1.75736C0.918246 2.59648 0.346802 3.66557 0.115291 4.82946C-0.11622 5.99335 0.0026002 7.19975 0.456726 8.2961C0.910853 9.39246 1.67989 10.3295 2.66658 10.9888C3.65328 11.6481 4.81332 12 6.00001 12C7.18669 12 8.34673 11.6481 9.33342 10.9888C10.3201 10.3295 11.0892 9.39245 11.5433 8.29609C11.9974 7.19974 12.1162 5.99334 11.8847 4.82945C11.6532 3.66556 11.0817 2.59647 10.2426 1.75735C9.11741 0.632137 7.59129 -1.50029e-06 5.99999 0C4.4087 1.5003e-06 2.88258 0.632143 1.75736 1.75736ZM9.42557 5.77157C8.84357 5.18958 8.05422 4.86262 7.23115 4.86262C6.40808 4.86262 5.61873 5.18958 5.03673 5.77158L6.35717 7.09202L2.51475 7.09202V3.24958L3.83516 4.57002C4.36094 4.04418 5.03097 3.68624 5.76037 3.54155C6.48976 3.39685 7.24569 3.47192 7.93238 3.75723C8.61908 4.04254 9.20563 4.52526 9.61773 5.14423C10.0298 5.76319 10.2489 6.49056 10.2473 7.23416C10.1136 6.68016 9.82916 6.17396 9.42557 5.77157Z" fill="#1C64F2"/>
                </g>
                <defs>
                  <clipPath id="clip0_47342_1387">
                    <rect width="12" height="12" fill="white"/>
                  </clipPath>
                </defs>
              </svg>
              Restore
            </button>
            <button
              type="button"
              class="tw-flex tw-items-center tw-gap-2 tw-font-inter tw-font-medium tw-text-sm tw-border tw-bg-red-700 tw-px-5 tw-rounded-lg tw-text-white tw-h-[42px] tw-whitespace-nowrap"
              (click)="openDeleteModal()"
            >
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_47342_24184)">
                  <path d="M12.7063 2.94737H9.85446V1.47368C9.85446 1.08284 9.70422 0.708001 9.43681 0.431632C9.1694 0.155263 8.80671 0 8.42853 0H5.57668C5.1985 0 4.83581 0.155263 4.5684 0.431632C4.30098 0.708001 4.15075 1.08284 4.15075 1.47368V2.94737H1.2989C1.10981 2.94737 0.928466 3.025 0.794759 3.16318C0.661053 3.30137 0.585938 3.48879 0.585938 3.68421C0.585938 3.87963 0.661053 4.06705 0.794759 4.20524C0.928466 4.34342 1.10981 4.42105 1.2989 4.42105H2.01186V12.5263C2.01186 12.9172 2.16209 13.292 2.42951 13.5684C2.69692 13.8447 3.05961 14 3.43779 14H10.5674C10.9456 14 11.3083 13.8447 11.5757 13.5684C11.8431 13.292 11.9933 12.9172 11.9933 12.5263V4.42105H12.7063C12.8954 4.42105 13.0767 4.34342 13.2104 4.20524C13.3442 4.06705 13.4193 3.87963 13.4193 3.68421C13.4193 3.48879 13.3442 3.30137 13.2104 3.16318C13.0767 3.025 12.8954 2.94737 12.7063 2.94737ZM5.57668 1.47368H8.42853V2.94737H5.57668V1.47368ZM6.28964 11.0526C6.28964 11.2481 6.21453 11.4355 6.08082 11.5737C5.94711 11.7118 5.76577 11.7895 5.57668 11.7895C5.38759 11.7895 5.20624 11.7118 5.07254 11.5737C4.93883 11.4355 4.86372 11.2481 4.86372 11.0526V5.89474C4.86372 5.69931 4.93883 5.5119 5.07254 5.37371C5.20624 5.23553 5.38759 5.15789 5.57668 5.15789C5.76577 5.15789 5.94711 5.23553 6.08082 5.37371C6.21453 5.5119 6.28964 5.69931 6.28964 5.89474V11.0526ZM9.14149 11.0526C9.14149 11.2481 9.06638 11.4355 8.93267 11.5737C8.79896 11.7118 8.61762 11.7895 8.42853 11.7895C8.23944 11.7895 8.0581 11.7118 7.92439 11.5737C7.79068 11.4355 7.71557 11.2481 7.71557 11.0526V5.89474C7.71557 5.69931 7.79068 5.5119 7.92439 5.37371C8.0581 5.23553 8.23944 5.15789 8.42853 5.15789C8.61762 5.15789 8.79896 5.23553 8.93267 5.37371C9.06638 5.5119 9.14149 5.69931 9.14149 5.89474V11.0526Z" fill="white"/>
                </g>
                <defs>
                  <clipPath id="clip0_47342_24184">
                    <rect width="14" height="14" fill="white"/>
                  </clipPath>
                </defs>
              </svg>
              Delete permanently
            </button>
          </div>
        </div>
      }
    </div>
  </div>
    @if (isInitialLoading()) {
        <div>
          <app-archived-items-skeleton />
        </div>
    } @else if (!archivedItems().length && searchTerm().trim() || !archivedItems().length && activeFilterCount() > 0) {
        <app-events-timeline-empty-state
          mode="search"
          heading="No items found."
          [showCreateButton]="false"
        />
    } @else if (!archivedItems().length) {
            <img src="assets/images/v2/archivedItemsEmptyState.svg" alt="Archived items empty state" class="tw-w-[321px] tw-h-[236px] lg:tw-w-[545px] lg:tw-h-[400px] tw-self-center tw-mt-20 lg:tw-mt-[72px] tw-mb-4">
            <p class="tw-font-inter tw-font-normal tw-text-base lg:tw-text-xl tw-text-gray-900 tw-text-center">No archived items in this event.</p>
    } @else {
        <app-desktop-archived-items-table
          [items]="archivedItems()"
          [selectedKeys]="selectedKeys()"
          [sort]="sortState()"
          [hasMore]="hasMore()"
          [isLoadingMore]="isPaginating()"
          [perPage]="perPage"
          [trackBy]="trackByItemId"
          [rowKey]="rowKeyFn"
          [menuOptions]="archivedItemMenuOptions"
          [virtualScrollMinBufferPx]="virtualScrollMinBufferPx"
          [virtualScrollMaxBufferPx]="virtualScrollMaxBufferPx"
          (selectionChange)="onSelectionChange($event)"
          (sortChange)="onSortChange($event)"
          (loadMore)="loadNextPage()"
          (menuOptionClick)="onMenuOptionClick($event)"
        />

        <div class="tw-relative tw-flex-1 tw-min-h-0 lg:tw-hidden">
            <cdk-virtual-scroll-viewport
              autosize
              class="archived-items-viewport"
              [minBufferPx]="virtualScrollMinBufferPx"
              [maxBufferPx]="virtualScrollMaxBufferPx"
              (scroll)="onViewportScroll()"
            >
              <div
                *cdkVirtualFor="let item of archivedItems(); trackBy: trackByItemId"
                class="archived-item-row"
              >
                <app-mobile-archived-item-card
                  [item]="item"
                  [archivedItemMenuOptions]="archivedItemMenuOptions"
                  [isSelected]="isItemSelected(item)"
                  (selectionToggle)="toggleItemSelection(item)"
                  (menuOptionClick)="onMenuOptionClick($event)"
                ></app-mobile-archived-item-card>
              </div>
            </cdk-virtual-scroll-viewport>

            @if (isPaginating()) {
              <div class="tw-absolute tw-bottom-2 tw-left-0 tw-right-0 tw-flex tw-items-center tw-justify-center tw-pointer-events-none">
                <progress-circle colorClasses="tw-border-blue-500 tw-border-r-gray-300"></progress-circle>
              </div>
            }
        </div>
    }
</div>

@if (isRestoreModalOpen()) {
  <delete-modal
    [id]="restoreModalId"
    [message]="restoreConfirmMessage()"
    [confirmBtnBgColorClass]="'tw-bg-blue-600'"
    (onDelete)="confirmRestore()"
    (onCancel)="cancelRestore()"
  ></delete-modal>
}

@if (isDeleteModalOpen()) {
  <delete-modal
    [id]="deleteModalId"
    [message]="deleteConfirmMessage()"
    (onDelete)="confirmDeletePermanently()"
    (onCancel)="cancelDeletePermanently()"
  ></delete-modal>
}

@if (isFilterDrawerOpen()) {
  <app-mobile-filter-drawer
    (reset)="onFilterReset()"
    (apply)="onFilterApply()"
  >
    <app-mobile-accordion title="Type">
      @for (option of typeFilterOptions; track option.value) {
        <app-filter-option
          [label]="option.label"
          [selected]="draftFilters().type === option.value"
          (selectedChange)="onTypeFilterSelect(option.value)"
        />
      }
    </app-mobile-accordion>

    <app-mobile-accordion title="Date range" [isLast]="true">
      @for (option of dateRangeFilterOptions; track option.value) {
        <app-filter-option
          [label]="option.label"
          [selected]="draftFilters().dateRange === option.value"
          (selectedChange)="onDateRangeFilterSelect(option.value)"
        />
      }
      @if (draftFilters().dateRange === 'custom') {
        <div class="tw-px-2 tw-mt-3">
          <app-date-range-picker
            #mobileCustomDateRangePicker
            [startDate]="draftFilters().customArchivedFrom"
            [endDate]="draftFilters().customArchivedTo"
            [showIndefiniteOption]="false"
            [isIndefinitely]="false"
            [maxSelectableDate]="archivedDatePickerMaxDate"
            [initialVisibleMonthDate]="archivedDatePickerMaxDate"
            [compactCalendarOnMobile]="true"
            [useModalOnMobile]="true"
            [useBasicInputTrigger]="true"
            [basicInputLabel]="'Date'"
            [basicInputPlaceholder]="'Select dates'"
            [mobileModalTitle]="'Custom date range'"
            (rangeSelected)="onDraftCustomDateRangeSelected($event)"
            [fieldType]="basicFieldType"
          />
        </div>
      }
    </app-mobile-accordion>
  </app-mobile-filter-drawer>
}

